const Colors = {
  blue: '#2e2d77',
  yellow: '#fed83a',
  yellowDark: '#fdbc0d',
  pink: '#ee365a',
  pinkDark: '#cd2188',
  green: '#88e24b',
  gray: '#b4b4b4',
  grayDark: '#383838',
  purple: '#462f4d',
  orange: '#fe6006',

  primary: '#fff',
  secondary: '#0c0928',
  background: '#f2f6f7',
  fontColor: '#000',
  fontColorHover: '#fff',
};

export default Colors;
